import { ROLLEN_ANZEIGE } from "@gui-creator/gemeinsam";
import { History, ListTodo, LogOut, Moon, Settings, Sun, Trash2 } from "lucide-react";
import { useEffect, useRef, type ReactNode } from "react";
import { NavLink, useLocation, useNavigate } from "react-router";
import { farbschemaSetzen, useWirksamesFarbschema } from "../stil/farbschema.ts";
import { useAbmelden, useKonto } from "./konto.ts";
import { useSchmal } from "./schmal.ts";

/** Am Handy eine Schublade von links mit Baum, Seitenlinks und Konto; breiter bleibt der Baum eine feste Spalte. */
export function Schublade({ offen, onSchliessen, children }: { offen: boolean; onSchliessen: () => void; children: ReactNode }) {
  const schmal = useSchmal();
  const ref = useRef<HTMLDivElement>(null);
  const schliessen = useRef(onSchliessen);
  schliessen.current = onSchliessen;
  const konto = useKonto();
  const abmelden = useAbmelden();
  const schema = useWirksamesFarbschema();
  const ort = useLocation();
  const navigate = useNavigate();
  const aufUi = ort.pathname.startsWith("/p/") && ort.pathname.split("/").filter(Boolean).length === 4;

  useEffect(() => {
    if (!schmal || !offen) return;
    const vorher = document.activeElement as HTMLElement | null;
    ref.current?.focus();
    const taste = (e: KeyboardEvent) => {
      if (e.key === "Escape") schliessen.current();
    };
    window.addEventListener("keydown", taste);
    return () => {
      window.removeEventListener("keydown", taste);
      vorher?.focus?.();
    };
  }, [schmal, offen]);

  return (
    <div ref={ref} className={`schublade${offen ? " schublade-offen" : ""}`} tabIndex={-1} inert={schmal && !offen}>
      {children}
      {schmal && (
        <nav className="schublade-nav" aria-label="Seiten">
          {aufUi && (
            <button
              type="button"
              onClick={() => {
                onSchliessen();
                navigate(`${ort.pathname}?ansicht=verlauf`);
              }}
            >
              <History size={16} aria-hidden="true" /> Verlauf dieser UI
            </button>
          )}
          <NavLink to="/todos" onClick={onSchliessen}>
            <ListTodo size={16} aria-hidden="true" /> Offene To-dos
          </NavLink>
          <NavLink to="/papierkorb" onClick={onSchliessen}>
            <Trash2 size={16} aria-hidden="true" /> Papierkorb
          </NavLink>
          <NavLink to="/einstellungen" onClick={onSchliessen}>
            <Settings size={16} aria-hidden="true" /> Einstellungen
          </NavLink>
          {schema === "dunkel" ? (
            <button type="button" onClick={() => farbschemaSetzen("hell")}>
              <Sun size={16} aria-hidden="true" /> Helle Darstellung
            </button>
          ) : (
            <button type="button" onClick={() => farbschemaSetzen("dunkel")}>
              <Moon size={16} aria-hidden="true" /> Dunkle Darstellung
            </button>
          )}
          <div className="schublade-konto">
            <span className="kopf-kuerzel" aria-hidden="true">
              {konto.name.slice(0, 1).toUpperCase()}
            </span>
            <span className="schublade-konto-text">
              {konto.name} <span className="leise">· {ROLLEN_ANZEIGE[konto.rolle]}</span>
            </span>
            <button type="button" className="knopf knopf-still" onClick={() => void abmelden()}>
              <LogOut size={14} aria-hidden="true" /> Abmelden
            </button>
          </div>
        </nav>
      )}
    </div>
  );
}
